import React, { useEffect, useState } from 'react';
import { dispatchService } from '../../services/central-api/dispatch';
import FilterDropdown from '../Filter/components/FilterDropdown';
import { translate } from '../../services/translate';
import { useAuth } from '../../context/Auth';
import { StyleProp, TextStyle } from 'react-native';
import { UseFormReturn } from 'react-hook-form';
import FormDropDownPicker from '../FormDropDownPicker';

type Props = {
    zIndex?: number;
    disabled?: boolean;
    labelFontSize?: number;
    label?: string;
    actingBodyId: number;
    labelStyle?: StyleProp<TextStyle>;
    viewStyle?: StyleProp<TextStyle>;
    required?: boolean;
    includeDeleted?: boolean;
} & ({
    form?: undefined;
    fieldName?: undefined;
    value: number;
    setValue: React.Dispatch<React.SetStateAction<number>>;
} | {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    form: UseFormReturn<any, any, any>;
    fieldName: string;
    value?: undefined;
    setValue?: undefined;
});

export default function UnitProgramDropdown({ form, fieldName, value, setValue, zIndex, disabled, labelFontSize = 16, label, actingBodyId, labelStyle, viewStyle, required, includeDeleted }: Props) {
    const [items, setItems] = useState<{ label: string; value: number; }[]>([]);
    const { user: authenticatedUser } = useAuth();

    async function getUnitPrograms(actingBodyId?: number) {
        try {
            const response = await dispatchService.getDropDownUnitPrograms(actingBodyId, includeDeleted);
            setItems(response.map(unitProgram => ({
                label: unitProgram.name,
                value: unitProgram.id
            })));
        } catch (err) {
            console.error(err);
        }
    }

    useEffect(() => {
        if ((authenticatedUser?.isAdmin
            || authenticatedUser?.permissions.dispatch_manage_all_acting_bodies_units
            || authenticatedUser?.permissions.dispatch_manage_acting_body_units) && !actingBodyId) {
            setItems([]);
            return;
        }

        getUnitPrograms(actingBodyId);
    }, [actingBodyId]);

    if (form && fieldName) {
        return <FormDropDownPicker
            label={label ?? translate('unitProgram')}
            items={items}
            multiple={false}
            zIndex={zIndex}
            disabled={disabled}
            required={required}
            fieldName={fieldName}
            form={form}
            labelFontSize={labelFontSize}
            labelStyle={labelStyle}
            viewStyle={viewStyle}
        />;
    } else if (value !== undefined && setValue !== undefined) {
        return (
            <FilterDropdown
                label={label ?? translate('unitProgram')}
                items={items}
                multiple={false}
                setValue={setValue}
                value={value}
                zIndex={zIndex}
                disabled={disabled}
                required={required}
                labelFontSize={labelFontSize}
                labelStyle={labelStyle}
                viewStyle={viewStyle}
            />
        );
    }
}
